/** Shared layout for HelpIcon + ChatbotWidget (stacked bottom-left, no overlap). */
export const CHAT_DOCK_EDGE = 24;
export const CHAT_DOCK_FAB_SIZE = 56;
export const CHAT_DOCK_GAP = 12;
/** ~HelpIcon footprint (padding + large icon). */
export const CHAT_DOCK_HELP_BLOCK = 56;

/** Help anchored at the dock edge (lowest control). */
export const chatDockHelpBottomPx = CHAT_DOCK_EDGE;

/** AI chat FAB sits above Help. */
export const chatDockFabBottomPx =
  CHAT_DOCK_EDGE + CHAT_DOCK_HELP_BLOCK + CHAT_DOCK_GAP;

/** Compact chat panel sits above the FAB. */
export const chatDockCompactPanelBottomPx =
  chatDockFabBottomPx + CHAT_DOCK_FAB_SIZE + CHAT_DOCK_GAP;
